import styled from 'styled-components';
import { BREAKPOINTS } from "../../../../../app/appConstants";

export const ProfileVerifyAlertWrapperStyled = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: wrap;
    padding: 8px;
    background: rgba(255, 255, 255, 0.05);
    min-width: 190px;
    width: 100%;
    border-radius: 16px;
    button {
        color: var(--color-white);
        border: none;
        &:hover {
            color: var(--color-white);
            border: none;
        }
    }
    @media (max-width: ${BREAKPOINTS.small}px) {
        padding: 16px;
    }
`;

export const ProfileVerifyAlertContainerStyled = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 12px;
    width: 100%;
    @media (max-width: ${BREAKPOINTS.small}px) {
        flex-direction: row;
        align-items: flex-start;
    }
`;

export const ProfileVerifyAlertIconStyled = styled.div`
    flex: 0 0;
    display: flex;
    margin-bottom: 6px;
    
    svg {
        fill: var(--color-negative);
    }
    
    @media (max-width: ${BREAKPOINTS.small}px) {
        margin-bottom: 0;
        margin-right: 6px;
    }
`;

export const ProfileVerifyAlertDescriptionStyled = styled.p`
    color: var(--icon-primary-color);
    font-size: 12px;
    font-weight: 400;
    text-align: center;
    margin-bottom: 0;
    @media (max-width: ${BREAKPOINTS.small}px) {
        text-align: left;
    }
`;
